var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "pddPrinting-new" } }, [
    _c(
      "div",
      {},
      [
        _c("orderCenter", {
          attrs: { accountList: _vm.accountList, statusOpts: _vm.statusOpts },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }